import { render, staticRenderFns } from "./TabHeaderItem.vue?vue&type=template&id=77705f5c&scoped=true"
import script from "./TabHeaderItem.vue?vue&type=script&lang=js"
export * from "./TabHeaderItem.vue?vue&type=script&lang=js"
import style0 from "./TabHeaderItem.vue?vue&type=style&index=0&id=77705f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77705f5c",
  null
  
)

export default component.exports